export const navodayaSubjectIdsByStandardVariant = {
  jawahar: {
    5: [26, 29, 72],
  },
  cet: {
    5: [17, 22, 23, 26, 29],
  },
  gnansetu8: {
    8: [17, 23, 26, 29, 31, 32, 33, 73],
  },
};

const getSubjectId = (item) => {
  const raw =
    item?.id ??
    item?.subject_id ??
    item?.subjectId ??
    item?.kram;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
};

export const filterNavodayaSubjectsByStandardVariant = (
  subjects,
  standardIndex,
  variant
) => {
  const key = String(variant || "jawahar").toLowerCase();
  const allowedIds = navodayaSubjectIdsByStandardVariant?.[key]?.[standardIndex];
  if (!allowedIds) return [];

  return (subjects || [])
    .map((item) => {
      const id = getSubjectId(item);
      if (id == null) return item;
      if (item?.id != null) return item;
      return { ...item, id };
    })
    .filter((item) => {
      const id = getSubjectId(item);
      return id != null && allowedIds.includes(id);
    })
    .sort(
      (a, b) =>
        allowedIds.indexOf(getSubjectId(a)) - allowedIds.indexOf(getSubjectId(b))
    );
};

export const filterNavodayaSubjectsByStandard = (subjects, standardIndex) => {
  return filterNavodayaSubjectsByStandardVariant(subjects, standardIndex, "jawahar");
};
